import Vue from 'vue';
import { DataService } from './data.service';
import { mapServices } from '../config/dataservices';
export class UIService {
	
    constructor(options) {
        options = options || {};
        this.urlService = options.urlService;
        this.dataService = new DataService();
        this.polyFillToggleAttribute();
        this.attachTabChangeListener();
        this.attachAppStateListener();
        this.attachGoogleAnalyticsListener();
        this.attachBaseMapListeners();
        this.attachPrintReportListeners();
        this.attachShareUrlListeners();
    }

    attachAppStateListener() {
        var modal;
        const elements = {
            appStartButton: document.querySelector('.js-app-start'),
            appCloseButton: document.querySelector('.js-app-close'),
            appModalOpenButton: document.querySelectorAll('.button-more-info'),
            appModalCloseButton: document.querySelectorAll('.button-modal-close'),
            appMobileMapToggle: document.querySelector('.js-mobile-map__toggle'),
            menuRevealToggle: document.querySelector('.js-menu-reveal__toggle'),
            appMapElement: document.querySelector('.map'),
            dropDownToggle: document.querySelectorAll('.js-dropdown__toggle'),
            dropDownMenu: document.querySelectorAll('.menu-dropdown'),
            appState: document.querySelector('#main'),
			comingSoon: document.querySelector('.comingSoon'),
			// modal: document.getElementById("agInfoModal"),
			// modalSpan: document.getElementsByClassName("info-close")[0],
        }

		/*
        window.addEventListener("load", (event) => {
            elements.modal.setAttribute('data-tab-modal-state', 'open');
            elements.modal.style.display = "block";
        }) */

        elements.appStartButton.addEventListener('click', event => {
            let isGeoIDSelected = DataService.ApplicationState.geoid !== null;
            const footerFull = document.querySelector('.footer-full');
            //console.log(footerHalf.innerHTML);
            //console.log(footerFull.innerHTML);
            //console.log(isGeoIDSelected);
            if (isGeoIDSelected) {
                elements.appState.setAttribute('data-app-state', 'active');
            }
            footerFull.style.display = "none";
        });

        elements.appCloseButton.addEventListener('click', event => {
            elements.appState.setAttribute('data-app-state', 'inactive');
        });

		
        [...elements.appModalOpenButton].forEach(element => element.addEventListener('click', event => {
            elements.appState.setAttribute('data-tab-modal-state', 'open');
        }));

        [...elements.appModalCloseButton].forEach(element => element.addEventListener('click', event => {
            elements.appState.setAttribute('data-tab-modal-state', 'closed');
        }));

        elements.appMobileMapToggle.addEventListener('click', event => {
            elements.appMapElement.classList.toggle('is-open-mobile');
        });

        elements.menuRevealToggle.addEventListener('click', event => {
            elements.appState.toggleAttribute('data-menu-open');
        });
		
		/*
		if(elements.comingSoon) {
			elements.comingSoon.addEventListener('click', event => {
				elements.modal.style.display = "block";
			});
		}

        elements.modalSpan.addEventListener('click', event => {
            elements.modal.style.display = "none";
        });
        
        window.onclick = function(event) {
            if (modal && event.target == modal) {
                modal.style.display = "none";
            }
        } */

        //if the app is being initialized from the url, skip the splash page
        if (this.urlService.initialParams.app) elements.appState.setAttribute('data-app-state', 'active');

        // [...elements.dropDownToggle].forEach(element => element.addEventListener('click', event => {
        //    elements.dropDownMenu.setAttribute('data-menu-open');
        // }));        
    }

    attachGoogleAnalyticsListener() {
		window.dataLayer = window.dataLayer || [];
		function gtag(){dataLayer.push(arguments);}
		gtag('js', new Date());
	
		gtag('config', 'G-3G3YQDVFV0');
	
        const googleEvents = document.querySelectorAll('.ga-event');
        [...googleEvents].forEach(element => element.addEventListener('click', event => {
            const gaEventLabel = event.target.getAttribute('data-ga');
            const gaEventAction = 'click';
            const gaEventCategory = 'CCAP Landcover Atlas';
            gtag('event', 'send', {
				'event_category': gaEventCategory,
				'event_label': gaEventLabel,
				'value': gaEventAction
			});
        }))
    }

    attachTabChangeListener() {
        const tabNames = {
            "tab1": "general",
            "tab2": "developed",
            "tab3": "forests",
            "tab4": "wetlands",
			"tab5": "agriculture"
        }
        let tabs = document.querySelectorAll('.js-charts-tab input[name="pct"]');

        [...tabs].forEach((tab, i) => {
            //set active tab from URL if available
            if (this.urlService.initialParams.app && this.urlService.initialParams.app.tab) {
                if (+this.urlService.initialParams.app.tab === (i + 1)) {
                    tab.setAttribute('checked', 'checked')
                    this.dataService.setTab(tabNames[tab.getAttribute("id")])
                }
                else {
                    tab.removeAttribute('checked')
                }
            }

            //set change event listener for each tab
            tab.addEventListener('change', event => {
                this.dataService.setTab(tabNames[event.target.getAttribute("id")]);
            })
        })
    }

    attachBaseMapListeners() {
        this.landCoverSelector = new Vue({
            el: '#ccapLayers',
            data: {
                fromYear: DataService.ApplicationState.fromYear,
                toYear: DataService.ApplicationState.toYear,
                layers: ['none'].concat(Object.keys(mapServices.landcover)).map(year => { //.unshift('none')
                    return {
                        year: year,
                        active: false
                    };
                })
            },
            methods: {
                isVisible: (year) => {
                    if (year === 'none') return true;
                    if (!this.landCoverSelector) return false;
                    return (+year === this.landCoverSelector.fromYear) || (+year === this.landCoverSelector.toYear);
                },
                changeLandCoverLayer: (event) => {
                    let newLayerIndex = event.currentTarget.getAttribute('data-index');
                    this.landCoverSelector.layers.forEach(l => { l.active = false });
                    this.landCoverSelector.layers[newLayerIndex].active = true;
                    this.dataService.setActiveLandCoverLayer(event.currentTarget.getAttribute('data-layer'))
                }
            }
        });
        //update visible options on to and from year change
        this.dataService.on('fromYearChange', (event, target) => {
            this.landCoverSelector.$refs.none[0].click();
            this.landCoverSelector.fromYear = target.data.newValue;
        });
        this.dataService.on('toYearChange', (event, target) => {
            this.dataService.setActiveLandCoverLayer('none')
            this.landCoverSelector.$refs.none[0].click();
            this.landCoverSelector.toYear = target.data.newValue;
        });

        //initialize with no landcover layer selected
        this.landCoverSelector.layers[0].active = true;

        this.basemapSelector = new Vue({
            el: '#basemaps',
            data: {},
            methods: {
                changeBasemap: (event) => {
                    this.dataService.setActiveBasemap(event.currentTarget.getAttribute('data-layer'))
                }
            }
        });
		
		this.changeVisibility = new Vue({
            el: '#differenceBtn',
            data: {},
            methods: {
                toggleDifferenceLayer: (event) => {
                    this.dataService.setChangeVisibility();
                }
            }
        });
    }

    attachPrintReportListeners() {
        const printReportBtn = document.querySelector('#printReport');
        printReportBtn.addEventListener('click', event => {
            const appState = DataService.ApplicationState;
            let regionType = appState.regionType === 'counties' ? 'County' : 'Watershed';
            let activeExtent = '-8956057,3826824,-8823387,3923896';
            let hiRes = "false";
            let url = "report.html?sn=" + appState.state + "&r=" + appState.location + "&rt=" + regionType + "&geoid=" + appState.geoid + "&ys=" + appState.fromYear + "&ye=" + appState.toYear + "&ext=" + activeExtent + "&hr=" + hiRes;
            let reportWindow = window.open(url, 'LandCoverReport', 'width=750,height=850,directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes');
            if (window.focus) {
                reportWindow.focus();
            }
        })

    }

    async attachShareUrlListeners() {
        const shareUrlBtn = document.querySelector('#shareUrlBtn');
        const shareUrlInput = document.querySelector('#shareUrl');
        shareUrlBtn.addEventListener('click', async event => {
            const shareURL = await this.urlService.generateShareURL(DataService.ApplicationState);
            shareUrlInput.value = shareURL;
        })
    }

    //Polyfill for toggleAttribute on IE
    polyFillToggleAttribute() {
        if (!Element.prototype.toggleAttribute) {
            Element.prototype.toggleAttribute = function (name, force) {
                if (force !== void 0) force = !!force

                if (this.hasAttribute(name)) {
                    if (force) return true;

                    this.removeAttribute(name);
                    return false;
                }
                if (force === false) return false;

                this.setAttribute(name, "");
                return true;
            };
        }
    }

}
